import { render, staticRenderFns } from "./PlainCards.vue?vue&type=template&id=0146f4ed"
import script from "./PlainCards.vue?vue&type=script&lang=js"
export * from "./PlainCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports